<template>
  <div class="mb-10">
    <div class="d-flex flex-row justify-center">
      <div :class="panelCSS" class="formPanel">
        <v-card
          class="mt-2 mb-4 pa-4"
          color="#ebebeb"
          bordered
          border-color="#000"
          flat
          :loading="loading"
        >
          <div
            class="d-flex flex-row flex-wrap justify-space-between align-center"
          >
            <div>
              <div class="text-h5">{{ pageTitle }}</div>
              <div class="caption py-1" v-if="data && data.slug">
                /{{ data.slug }}

                <span v-if="data && data.slug && data.slug != ''"
                  ><v-btn icon x-small @click="editSlugPrompt()"
                    ><v-icon x-small color="primary">mdi-pencil</v-icon></v-btn
                  ></span
                >
              </div>
            </div>
            <div>
              <v-btn depressed @click="exitPage()" class="mx-2" text>
                Cancel</v-btn
              ><v-btn
                :disabled="!valid"
                depressed
                color="primary"
                class="mx-2"
                @click="doSave()"
                text
              >
                Save</v-btn
              >
            </div>
          </div>

          <div
            class="caption d-flex flex-row flex-wrap align-center"
            v-if="data"
          >
            <div class="mx-3" v-if="!newItem">id: {{ data.id }}</div>
            <div class="mx-3" v-if="data.added">Added: {{ data.added }}</div>
            <div class="mx-3" v-if="data.updated">
              Updated: {{ data.updated }}
            </div>
            <v-checkbox
              class="mx-3 my-0 py-0"
              v-model="data.display"
              dense
              :hide-details="true"
              label="Publish"
            ></v-checkbox>
          </div>
        </v-card>
        <v-alert type="warning" v-if="error">{{ error }}</v-alert>

        <v-form v-model="valid" v-if="data" class="mb-2" lazy-validation>
          <v-text-field
            label="Name"
            v-model="data.name"
            outlined
            class="mr-4"
            @change="nameChange()"
            :rules="nameRules"
            required
          ></v-text-field>
          <div class="d-flex flex-row">
            <v-text-field
              label="Website"
              v-model="data.url"
              outlined
              class="mr-4"
              placeholder="https://www.website.com"
            ></v-text-field>

            <v-btn
              text
              small
              @click="showIframe = !showIframe"
              v-if="data.url"
              color="primary"
              >open
              <v-icon small color="primary" class="mx-2"
                >mdi-view-split-vertical</v-icon
              ></v-btn
            >
          </div>
          <div class="d-flex flex-row">
            <v-text-field
              v-model="data.phone"
              label="Phone"
              outlined
              class="mr-4"
            ></v-text-field>
            <v-text-field
              v-model="data.email"
              label="Email"
              outlined
              class="mr-4"
            ></v-text-field>
          </div>
          <!-- <div class="d-flex flex-row mb-4">
            <v-checkbox
              v-model="data.hasMaterials"
              label="Makes Materials (rgp buttons)"
              :hide-details="true"
              input-value="1"
              class="mr-4"
            ></v-checkbox>
            <v-checkbox
              v-model="data.hasLenses"
              label="Makes Lenses"
              :hide-details="true"
              input-value="1"
            ></v-checkbox>
          </div> -->
          <div class="overline">More Info</div>
          <md-textarea v-model="data.comments"></md-textarea>
        </v-form>
        <div v-if="data && data.id > 0">
          <v-divider class="my-2"></v-divider>
          <div class="mt-2">
            <!-- <div class="overline">Lenses</div> -->
            <quick-add-items
              :currentItems="lenses"
              @newItems="newItems = $event"
            ></quick-add-items>
          </div>
        </div>

        <v-divider class="my-2"></v-divider>
        <!-- <image-browser-uploader
          v-if="data && data.slug"
          :fileNameRoot="data.slug"
          :previousFiles="[data.image]"
          :limit="1"
          path="/images/rgp_companies/"
          @fileList="newImageFiles = $event"
          class="my-1"
        ></image-browser-uploader> -->

        <media-uploader
          v-if="data && data.slug"
          :fileNameRoot="data.slug"
          :previousFiles="data.media"
          :title="null"
          dir="rgp_companies"
          :limit="1"
          :oneFile="true"
          :productId="data.id"
          accept=".svg,.jpg,.jpeg,.png"
          @fileList="data.media = $event"
        ></media-uploader>

        <v-card color="#fffde8" flat outlined class="my-4" v-if="data">
          <v-card-text>
            <div class="caption">(For internal use only)</div>
            <v-text-field
              label="Contact Person Name"
              v-model="data.contact_name"
              outlined
              class="compact-select"
            ></v-text-field>
            <v-text-field
              label="Contact Person Email"
              v-model="data.contact_email"
              outlined
              class="compact-select"
            ></v-text-field>
          </v-card-text>
        </v-card>
        <!-- end form panel -->
      </div>

      <div v-if="iframeSrc && showIframe" :class="panelCSS">
        <div class="d-flex flex-row justify-space-between">
          <v-btn
            text
            x-small
            color="primary"
            :href="data.url"
            v-if="data.url"
            target="_blank"
            >Open in new tab
            <v-icon color="primary" small>mdi-open-in-new</v-icon></v-btn
          >
          <v-btn x-small color="primary" text @click="showIframe = false"
            >Close</v-btn
          >
        </div>
        <iframe
          :src="iframeSrc"
          class="width100p"
          style="height: 90vh"
        ></iframe>
      </div>
    </div>
    <!-- <v-card class="my-8">{{ data }}</v-card> -->
    <v-alert v-if="error">{{ error }}</v-alert>
    <v-snackbar v-model="updatedSnackbar" :timeout="2000" top color="success">
      {{ pageTitle }} Updated</v-snackbar
    >
    <v-snackbar v-model="deletedSnackbar" :timeout="2000" top color="alert">
      {{ pageTitle }} Deleted</v-snackbar
    >
    <!-- {{ data }} -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import UserMixin from "@/assets/js/UserMixin";
import ApiOptionsMixin from "@/assets/js/ApiOptionsMixin";
import Slugify from "slugify";
import MdTextarea from "@/components/adminStuff/MdTextarea";
import QuickAddItems from "@/components/adminStuff/QuickAddItems";

export default {
  name: "EditRgpCompany",
  components: {
    // ImageBrowserUploader: () =>
    //   import("@/components/adminStuff/ImageBrowserUploader"),
    MediaUploader: () => import("@/components/adminStuff/MediaUploader"),
    MdTextarea,
    QuickAddItems,
  },
  mixins: [UserMixin, ApiOptionsMixin],
  props: {
    slug: null,
  },
  data: function () {
    return {
      loading: false,
      pageTitle: "Add Company",
      // apiPath: "/rgps/addCompany389",
      newImageFiles: [], // t
      updatedSnackbar: false,
      deletedSnackbar: false,
      iframeSrc: null,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length >= 6) || "Name must be at least characters",
      ],
      notNull: [(v) => !!v || "Category is required"],
      additionalFields: [],
      defaultData: {
        id: 0,
        name: "",
        slug: "",
        // hasMaterials: 0,
        // hasLenses: 0,
        media: [],
        url: null,
        phone: null,
        email: null,
        comments: null,
        contact_name: null,
        contact_email: null,
        display: 1,
        added: null,
        updated: null,
      },
      data: null,
      valid: false,
      // newLenses: [],
      newItems: [], // will hold any new lenses "quick added" for this company

      slugManuallyUpdated: false,
      error: null,
      showIframe: false,

      lenses: null,
    };
  },
  methods: {
    getData() {
      this.loading = true;
      if (!this.slug) return; // show error?
      this.error = null;
      ApiServices.rgpCompanyDetails(this.slug, true) // admin = true
        .then((response) => {
          this.populateContentFromAPI(response.data?.details);
          this.lenses = response.data?.lenses;
          this.pageTitle = this.data.name;
          this.error = null;
        })
        .catch((error) => {
          console.log("error", error);
          if (error) this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exitPage() {
      this.$router.push({ path: "/boss/rgp-companies" });
    },
    doSave() {
      this.loading = true;
      let data = { ...this.data };
      data.image =
        this.newImageFiles && this.newImageFiles.length
          ? this.newImageFiles[0]
          : null; // just return first item in array
      data.newItems = this.newItems;
      this.error = null;
      data.auth = this.auth_credentials;
      // console.log("calling" + this.apiPath);

      let apiPath = this.metaOptions?.adminAPIs?.addCompany; // from ApiOptionsMixin
      if (!apiPath) {
        console.log("no API path");
        return;
      }
      ApiServices.genericUpdateItem("/rgps/" + apiPath, data)
        .then((response) => {
          if (response.data.error) {
            this.error = response.data.error;
          } else if (response.data.success) {
            this.error = null;
            this.updatedSnackbar = true;
            this.exitPage();
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
        })
        .finally(() => {});
    },
    resetAll: function () {
      this.data = { ...this.defaultData };
      this.pageTitle = "Add RGP Company";
    },
    populateContentFromAPI(data) {
      if (data?.display) data.display = parseInt(data.display);
      data.hasMaterials = data?.hasMaterials == "1";
      data.hasLenses = data?.hasLenses == "1";
      // if (data.image) data.media = [data.image];
      this.iframeSrc = data.url;
      this.data = data;
    },

    nameChange() {
      if (this.data.name != "") this.pageTitle = this.data.name;
      if (!this.slugManuallyUpdated && this.newItem)
        this.updateSlug(this.data.name);
    },
    updateSlug(val) {
      if (val && this.data) {
        val = val.replace(/[()]/g, " ");
        this.data.slug = Slugify(val.toLowerCase());
      }
    },

    editSlugPrompt() {
      if (!this.data?.slug) return;
      let txt = "Choose a new vanity URL for item.";
      if (!this.newItem)
        txt +=
          "\n\nPlease be aware that changing the vanity URL will break any existing links to this item's listing! ";
      let newSlug = prompt(txt, this.data.slug);
      if (newSlug && newSlug != this.data.slug) {
        this.updateSlug(newSlug);
        this.slugManuallyUpdated = true;
      }
    },
  },
  computed: {
    headerClass: function () {
      return this.$vuetify.breakpoint.smAndUp ? "bigHead" : "smallHead";
    },

    newItem: function () {
      return this.slug == "new";
    },
    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    panelCSS: function () {
      if (this.showIframe && this.data.url && !this.isMobile)
        return "halfScreen";
      return "width100p";
    },
  },
  watch: {},

  mounted() {
    // the following references userMixin & ApiOptionsMixin.
    // Sets the 'metaOptions' variable with the api method name
    this.getItemOptions("/rgps/options?", "admin=1&" + this.auth_paramstring);
    if (!this.newItem) {
      this.getData();
    } else {
      this.resetAll(); // uses default data
    }
  },
  metaInfo() {
    return {
      title: "EyeDock Admin - RGP Companies " + this.pageTitle,
    };
  },
};
</script>

<style scoped>
.bigHead {
  min-width: 150px;
  max-width: 150px;
}
.bigHead {
  width: 100%;
}
.headerBkg {
  background-color: #e0f2ff;
  /* border-bottom: 1px solid #bfd5e5; */
  /* margin-bottom: -1px; */
}
.rowColor {
  background-color: #eaf6ff;
}
.sectionDiv {
  border: 1px solid #bfd5e5;
  margin-bottom: -1px;
}
.halfScreen {
  width: 45vw;
  height: 90vh;
  overflow-y: scroll;
}
.formPanel {
  max-width: 800px;
  border: 1px solid gray;
  margin: 1em;
  padding: 0 1em;
}
</style>
